import { render, staticRenderFns } from "./TheScreenshotButton.vue?vue&type=template&id=d3c0ab40&scoped=true&lang=html"
import script from "./TheScreenshotButton.vue?vue&type=script&lang=ts"
export * from "./TheScreenshotButton.vue?vue&type=script&lang=ts"
import style0 from "./TheScreenshotButton.vue?vue&type=style&index=0&id=d3c0ab40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c0ab40",
  null
  
)

export default component.exports